export default "__VITE_ASSET__B2b_Ezl$__"